import { isBoolean } from "ramda-adjunct";
import { Subject } from "rxjs";
import { subscribeSubject, subscribeSubjectND } from "../../utility";
import { EOL_REACHED } from "./load.model";

export const compName = comp => comp.$el.className;

export const createFetchListMixin = (
  FetchAction = "ProductList.FETCH.ALL",
  defaultRowCount = 100,
  options = {
    advancedSearchable: true,
    searchable: true,
    scrollable: true
  }
) => {
  return {
    mounted() {
      if (!isBoolean(options.searchable)) {
        throw Error("Pass in a proper searchable: true/false in the 3rd argument of CreateFetchListMixin Function");
      }
      if (!isBoolean(options.scrollable)) {
        throw Error("Pass in a proper scrollable: true/false in the 3rd argument of CreateFetchListMixin Function");
      }

      if (options.advancedSearchable) {
        if (this.fetchAdvancedSearchData) {
          this.fetchAdvancedSearchData();
        } else {
          throw Error(
            `Define fetchAdvancedSearchData Method in component: ${compName(
              this
            )}`
          );
        }

        if (!this.advancedSearchData) {
          throw Error(
            `Define a Computed Property advancedSearchData in Component ${compName(
              this
            )}`
          );
        }
      }

      if (this.fetchListReset) {
        this.fetchListReset();
      } else {
        throw Error("Define fetchListReset Method in component");
      }

      if (options.searchable) {
        subscribeSubject(this, this.searchSubject, searchString => {
          if (this.isSearchFilterActive) {
            this.resetSearchFilter();
          }
          this.fetchListReset();
        });

        if (!this.defaultBasicFilter) {
          throw Error(
            `Define defaultBasicFilter Method in component: ${compName(this)}`
          );
        }
      }

      if (options.scrollable) {
        subscribeSubjectND(this, this.scrollSubject, scrollTop => {
          if (this.start == this.loadedStart) {
            console.log({'fetch-list.mixin.js:70 loadedStart' : this.loadedStart, start: this.start});
            
            this.start += this.row_count;
            // console.log({ 'fetch-list.mixin.js:68 this.start': this.start });
            this.fetchListNext();
          }
        });
      }
    },
    data() {
      return {
        basicFilter: this.defaultBasicFilter(),

        loadedStart: 0,
        eol_flag: false,

        start: 0,
        row_count: defaultRowCount, // FIXED because of Initial API

        searchSubject: new Subject(),
        // searchString: "",

        scrollSubject: new Subject(),
        loadingFlag: false, // This is for List Loading

        advancedSearchResponse: null // Store All Advanced Search Dropdown Options Data / TextField Value / HTML UI Data here
      };
    },
    computed: {
      isSearchFilterActive() {
        if (!this.searchFilter) {
          return false;
        }
        return Object.values(this.searchFilter)?.length > 0
          ? Object.values(this.searchFilter).some(e => e)
          : false;
      },
      isNoBasicFilterActive() {
        return Object.keys(this.basicFilter).every(e => {
          return this.basicFilter[e] == this.defaultBasicFilter()[e];
        });
      },
      metaFilter() {
        // console.log({ "this.searchFilter": this.searchFilter });
        // console.log({ "this.isSearchFilterActive": this.isSearchFilterActive });
        // console.log({
        //   "this.isNoBasicFilterActive": this.isNoBasicFilterActive
        // });
        return {
          start: this.start,
          row_count: this.row_count,
          searchMode: this.isSearchFilterActive
            ? "advanced"
            : this.isNoBasicFilterActive
              ? "none"
              : "basic"
        };
      }
    },
    methods: {
      resetBasicFilter() {
        return (this.basicFilter = this.defaultBasicFilter());
      },
      onSearchInputKeyup: function (event) {
        this.basicFilter.searchString = event.target.value;
        this.searchSubject.next(this.basicFilter.searchString);
      },
      onListScroll: function (value) {
        this.scrollSubject.next(value);
      },
      fetchListReset: function () {
        this.start = 0;
        this.loadedStart = 0;
        this.eol_flag = false;

        this.fetchList();
      },
      fetchList: async function () {
        if (this.eol_flag === false) {
          this.loadingFlag = true;
          // console.log({ 'fetch-list.mixin.js:143 this.loadingFlag': this.loadingFlag });
          const loadStatus = await this[FetchAction](this.filter);
          // console.log({ 'fetch-list.mixin.js:145 this.filter': this.filter, m: this.metaFilter });
          if (loadStatus === EOL_REACHED) {
            this.eol_flag = true;
          }
          this.loadingFlag = false;
          // console.log({ 'fetch-list.mixin.js:150 this.loadingFlag': this.loadingFlag });
        }
      },
      fetchListNext: async function () {
        // console.log({ 'fetch-list.mixin.js:155 fetchListNext': 1 });
        await this.fetchList();
        this.loadedStart = this.start;
      },

      // This is reusing the Components Dropdown Change Method 
      // Reducing Further code in Component
      // Should Work for all Basic Filter Dropdowns -
      // "@plugins/dropdown/dropdown";
      // DOES NOT WORK - for Multiple Dropdowns in a Component
      onDropdownChange(name, event) {
        this.basicFilter[name] = event.value;
        console.log({ 'fetch-list.mixin.js:167 this.basicFilter': this.basicFilter });
        console.log({'fetch-list.mixin.js:183 this.isSearchFilterActive' : this.isSearchFilterActive, sf: this.searchFilter});
        if (this.isSearchFilterActive) {
          this.resetSearchFilter();
        }
        this.fetchListReset();
      },

      // This is the Multiple->String Dropdown Change Handler
      // Concatenates all the values of the Dropdowns with Commas
      onMultiDropdownChange(name, event) {
        this.basicFilter[name] = event?.length > 0 ? event?.map((e) => e.value).join(",") : "";
        console.log({'fetch-list.mixin.js:183 this.isSearchFilterActive' : this.isSearchFilterActive});

        if (this.isSearchFilterActive) {
          this.resetSearchFilter();
        }
        this.fetchListReset();
      }
    }
  };
};

// Data:
//   basicFilter
//   loadedStart
//   eol_flag
//   start
//   row_count
//   searchSubject
//   scrollSubject
//   loadingFlag
// advancedSearchResponse

// Computed:
//   isSearchFilterActive
//   isNoBasicFilterActive
//   metaFilter

// Methods:
//   resetBasicFilter
//   onSearchInputKeyup
//   onListScroll
//   fetchListReset
//   fetchList
//   fetchListNext